import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

export default function RequestChangesDialog({ open, onOpenChange, api, projectId, files, onDone }) {
  const [comment, setComment] = useState("");
  const [fileId, setFileId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) { setComment(""); setFileId(files[files.length - 1]?.id || ""); }
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!comment.trim() || busy) return;
    setBusy(true);
    try {
      await api.post(`/client/projects/${projectId}/request-changes`, { comment, file_id: fileId || null });
      toast.success("Your comments were sent to your manager.");
      onOpenChange(false); onDone && onDone();
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't send your request"); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[1.25rem] max-w-md" data-testid="request-changes-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Request changes</DialogTitle>
          <DialogDescription>Tell your manager what should change. They'll be notified right away.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {files.length > 1 && (
            <div><label className="label-caps block mb-1">Draft</label>
              <select data-testid="request-changes-file" value={fileId} onChange={(e) => setFileId(e.target.value)}
                className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm bg-white">
                {files.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
              </select></div>
          )}
          <div><label className="label-caps block mb-1">Your comments</label>
            <Textarea data-testid="request-changes-comment" required rows={6} maxLength={5000} value={comment}
              onChange={(e) => setComment(e.target.value)} placeholder="e.g. Please update the abstract on page 2 and fix the reference format." className="rounded-lg border-black/15" /></div>
          <button data-testid="request-changes-submit" type="submit" disabled={busy || !comment.trim()}
            className="w-full h-11 rounded-full font-semibold text-sm bg-[#B45309] text-white disabled:opacity-50">
            {busy ? "Sending…" : "Send to manager"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
